<template>
    <v-flex
        xs8
        :offset-xs4="message.fromMe === 1"
        class="mb-1"
        :key="message.id"
    >
        <v-card
        :dark="message.fromMe === 1"
        class="shadow-2"
        :color="message.fromMe === 1 ? 'secondary' : ''"
        >
        <v-card-text class="pb-1">
            <v-alert
                v-if="message.isDeleted === 1"
                dense
                colored-border
                type="info"
                :key="item.id"
                >
                Mensaje eliminado.
            </v-alert>

            <v-alert
                v-if="message.answered_message != null"
                elevation="0"
                text
                color="info"
                class="caption shadow-1"
                colored-border
                border="left"
                style="border-radius: 8px !important;"
            >
                <div>
                    <strong :class="message.fromMe == 1 ? 'cyan--text text--lighten-2' : 'info--text'">
                        {{ message.answered_message.fromMe == 1 ? 'Tú' : NameClient }}
                    </strong>
                </div>
                <caption v-if="message.answered_message.mediaType == 'chat'">
                    {{ message.answered_message.body }}
                </caption>
            </v-alert>

            <br>

            <v-card
            outlined
            style="border-radius: 9px !important"
            >
            <v-card-body>
                <v-container>
                <v-row align="center">
                    <v-col>
                    <v-list-item dense class="px-0">
                        <v-list-item-icon class="ml-0 mr-2">
                        <v-icon
                            large
                            v-if="message.mediaUrl.endsWith('.pdf')"
                        >
                            mdi-file-pdf-box
                        </v-icon>
                        <v-icon
                            large
                            v-else-if="
                            message.mediaUrl.endsWith('.xls') ||
                                message.mediaUrl.endsWith('.xlsx') ||
                                message.mediaUrl.endsWith('.csv')
                            "
                        >
                            mdi-file-excel-box
                        </v-icon>
                        <v-icon
                            large
                            v-else-if="
                            message.mediaUrl.endsWith('.doc') ||
                                message.mediaUrl.endsWith('.docx') ||
                                message.mediaUrl.endsWith('.odt')
                            "
                        >
                            mdi-file-word-box
                        </v-icon>
                        <v-icon v-else>mdi-file</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                        <v-list-item-title>
                            {{ message.observaciones }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            {{ message.mediaUrl | typeDoc }}
                        </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    </v-col>
                </v-row>
                </v-container>
            </v-card-body>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn
                block
                depressed
                :href="message.mediaUrl"
                target="_blank"
                >
                {{
                    message.mediaUrl.endsWith(".pdf")
                    ? "Abrir"
                    : "Descargar"
                }}
                </v-btn>
            </v-card-actions>
            </v-card>

            <p class="text--body-2 mt-3 mb-1">
            {{ message.body }}
            </p>

            <span class="ml-n2">
            <v-icon
                v-if="message.ack >= 1"
                small
                :color="message.ack === 3 ? 'teal lighten-2' : ''"
                >mdi-check</v-icon
            >
            <v-icon
                v-if="message.ack >= 2"
                small
                class="ml-n3"
                :color="message.ack === 3 ? 'teal lighten-2' : ''"
                >mdi-check</v-icon
            >
            </span>
            <small>
            {{ message.created_at | getHour12Format }}
            </small>
        </v-card-text>
        <v-avatar v-if="message.reaction" color="blue-grey darken-4" size="26" class="ml-1 mb-n3">
                {{message.reaction}}
            </v-avatar>
        </v-card>
    </v-flex>
</template>

<script>
import moment from "moment";

export default {
    props: {
        message: {
            type: Object,
        },
        NameClient: {
            type: String,
        },
    },

    filters: {
        getHour12Format(date) {
            const hour = moment(date).format("LT");
            return hour;
        },

        typeDoc(item) {
            const indicePunto = item.lastIndexOf(".");

            // Si se encuentra un punto, extrae los caracteres desde ese punto hasta el final
            if (indicePunto !== -1) {
                return item.slice(indicePunto + 1);
            } else {
                // Si no se encuentra un punto, devuelve la cadena completa
                return item;
            }
        },
    }
}
</script>